import React, { useState } from 'react'
import InfoIcon from '@mui/icons-material/Info'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material'

import { ManagePageForm } from './ManagePageForm'

export interface ManagePageCatalogProps {
  id: string
  pageName: string
}

export default function ManagePageCatalog({
  id,
  pageName
}: ManagePageCatalogProps) {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <div>
      <IconButton
        size='small'
        color='primary'
        aria-label='open-manage-page-catalog-modal'
        onClick={(event) => {
          event.stopPropagation()
          handleOpen()
        }}
      >
        <InfoIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='lg'
        aria-labelledby='manage-page-catalog-title'
        PaperProps={{
          sx: {
            width: '980px',
            maxWidth: '980px'
          }
        }}
      >
        <DialogTitle id='manage-page-catalog-title'>
          Manage Page Catalogs
        </DialogTitle>
        <DialogContent dividers>
          <ManagePageForm pageId={id} destinationName={pageName} />
        </DialogContent>
      </Dialog>
    </div>
  )
}
